export const formatDate = (date) => {

    var d = new Date(date.split('+')[0]),
        month = '' + (d.getUTCMonth() + 1),
        day = '' + (d.getUTCDate()),
        year = d.getUTCFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('/');
}

export const formatDateYMD = (date) => {

    try {
        const d = new Date(date.split('+')[0]);
        const month = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');
        const year = d.getUTCFullYear();

        return [year, month, day].join('-');

    } catch (error) {
        const d = new Date(date);
        const month = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');
        const year = d.getUTCFullYear();

        return [year, month, day].join('-');
    }
}

export const formatDateTime = (date) => {

    var d = new Date(date.split('+')[0]),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = d.getHours(),
        min = d.getMinutes(),
        sec = d.getSeconds();

    if (month.length < 2) {
        month = '0' + month;
    }

    if (day.length < 2) {
        day = '0' + day;
    }


    let dt = [day, month, year].join('/');
    let hr = [hour, min < 10 ? min +'0' : min , sec + '0'].join(':');

    const dateTime = dt + ' ' + hr;

    return dateTime;
}

export function formatarData(str) { //função para deixar a data na agenda igual do Google
    var meses = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro",
                 "Outubro","Novembro","Dezembro"];

    var dias = ["domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"]

    var partes = str.split('/').map(Number);

    var data = new Date('20' + partes[2], partes[1] - 1, partes[0]);
    var diaSemana = dias[data.getDay() % 7];
    var ano = partes[2];
    var mes = meses[data.getMonth()];

    return `${mes.slice(0, 3).toUpperCase()}. ${ano}, (${diaSemana.slice(0, 3).toUpperCase()}).`;
}

export function pegarHora(str) { //função para agenda

    var partes = str.split(' ').map(String);

    if (partes.length > 1) {
        var horas = partes[1];
        var horasSplice = horas.slice(0, 5);

        return horasSplice;
    }

    var partesT = str.split('T').map(String);

    var horasT = partesT[1];
    var horasSpliceT = horasT.slice(0, 5);

    return horasSpliceT;

}

export function pegarDia(str) { //função para agenda

    var partesT = str.split('T').map(String);

    if (partesT.length > 1) {
        var diaT = partesT[0].split('-');
        diaT = diaT[diaT.length-1];

        return diaT;

    }

    var partes = str.split('-').map(String);
    var partesDia = partes[2].split(' ').map(String);

    var dia = partesDia[0];

    return dia;
}

export function parseDateToObject(date) {
    if (typeof date !== 'string') {
        if (date instanceof Date) return date;
        date = String(date);
    }
    const obj = new Date(date.split('+')[0]);
    return obj;
}

export const formatDateTimeValidate = (date) => {
    const d = new Date(date.split('+')[0]);

    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();

    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');

    return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;
}